import { RequisitesCascadeMode } from 'enums';
import { Trader } from 'types';

import { P2PProvider } from './p2p-provider.type';
import { Shop } from './shop.type';

export type CascadeP2PProviderConfig = {
  id: string;
  cascadeId: string;
  p2pProviderId: string;
  p2pProvider?: Partial<P2PProvider>;
  priority: number;
};

export enum OrderAssigneeType {
  Trader = 'trader',
  P2PProvider = 'p2p_provider',
  AnyTrader = 'any_trader',
}

export type CascadePayoutOrderAssignee = {
  id: string;
  cascadeId: string;
  assigneeType: OrderAssigneeType;
  p2pProviderId: string;
  p2pProvider?: Partial<P2PProvider>;
  traderId: string;
  trader?: Partial<Trader>;
  priority: number;
  timeout: number;
};

export type Cascade = {
  id: string;
  createdAt: string;
  name: string;
  payinCascadeMode: RequisitesCascadeMode;
  payoutCascadeMode: RequisitesCascadeMode;
  p2pProvidersConfigs?: CascadeP2PProviderConfig[]; // payin
  payoutP2PProvidersConfigs?: CascadeP2PProviderConfig[]; // payout providers_only + trader_first
  payoutOrderAssignees?: CascadePayoutOrderAssignee[]; // payout mixed mode
  payoutOrderAssigneesTimeout?: number;
  payinParallelPriorityTimeout?: number; // payin parallel_priority mode, seconds
};

export type CascadesCashbackData = Partial<Shop> & {
  cascade: Cascade;
};
